<template>
  <div>
    <!-- メイン -->
    <v-main>
      <v-container>

        <v-card flat max-height="10vh" class="mb-6">
          <v-row>
            <v-col cols="12" class="d-flex align-center justify-center text-h4">
              <span class="vf-font-title" style="font-weight: bold;">本人確認のご案内</span>
            </v-col>
          </v-row>
        </v-card>

        <v-card :loading="loading"  max-height="32vh" rounded="xl" color="green lighten-1" class="mx-0 mx-sm-16 mx-xl-16">
          <v-row>
            <!-- <v-col cols="4" class="d-flex align-center justify-end">
              <v-img src="@/assets/img/img-tqs.png" :max-width="imageTqsWidth"
              ></v-img>
            </v-col> -->
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h6 text-md-h5 text-lg-h5 text-xl-h4 mt-2">
              <span class="vf-font-logo">{{ $t("LCMV000") }}</span>
            </v-col>
          </v-row>
          <v-row class="text-body-1 text-sm-h5 text-xl-h5 mt-0">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center pr-0">
              氏名：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start pl-0">
              {{ appName }} 様
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row align="center" justify="center" class="text-body-1 text-sm-h5 text-xl-h5 mt-0" v-show="false">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center  pr-0">
              性別：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start  pl-0">
              {{ appSex }}
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row align="center" justify="center" class="text-body-1 text-sm-h5 text-xl-h5 mt-0"  v-show="false">
            <v-col cols="1"></v-col>
            <v-col cols="5" class="d-flex align-center justify-center">
              生年月日：
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-start pl-0">
              {{ appBirthday }}
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-card>

        <v-card max-height="18vh" flat class="mt-6">
          <v-row>
            <v-col cols="1"></v-col>
            <v-col cols="10" class="d-flex align-center justify-center text-h6 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">
              <p>お疲れ様でした。</p>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center text-h6 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">
              <p>本人確認の申請が完了しました。</p>
            </v-col>
          </v-row>
        </v-card>

        <v-card flat max-height="32vh" class="mb-6">
              <v-row class="mt-0">
                <v-col cols="12" class="d-flex align-center justify-center">
                  <v-img src="@/assets/img/business_ojigi_woman.png" :max-width="imageStepWidth"></v-img>
                </v-col>
              </v-row>
        </v-card>

        <v-card max-height="18vh" flat class="mt-8">
          <v-row>
            <!-- <v-col cols="12" class="d-flex align-center justify-center">
              <v-btn x-large color="success" min-height="80px" :min-width="imageNextBtnWidth" dark @click="close()" class="text-h5">閉じる</v-btn>
            </v-col> -->
          </v-row>
        </v-card>

      </v-container>
    </v-main>
  </div>
</template>
<script>
export default {
  name: "VFAppCompleted",
  data() {
    return {
      screenTitle: "申請完了",
      screenId: "APA500",
      loading: false,
      appName: "",
      appSex: "",
      appBirthday: "",
    };
  },
  computed: {
    imageTqsWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs" || bp == "sm" || bp == "md") {
        return "30%";
      } else if (bp == "lg") {
        return "20%";
      } else if (bp == "xl") {
        return "14%";
      } else {
        return "14%";
      }
    },
    imageStepWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs") {
        return "60%";
      } else if (bp == "sm" || bp == "md") {
        return "40%";
      } else if (bp == "lg" || bp == "xl") {
        return "20%";
      } else {
        return "38%";
      }
    },
    imageNextBtnWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs" || bp == "sm") {
        return "98%";
      } else if (bp == "md" || bp == "lg" || bp == "xl") {
        return "20%";
      } else {
        return "98%";
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {

    /**
     * 初期表示
     */
    initialize: function() {
      this.appName = this.$store.getters["vfAppInfo/getAppName"];
    },

    // close: function() {
    //   // window.close();
    //   // open('about:blank', '_self').close();    //一度再表示してからClose
    //   return false;
    // },
  },
}
</script>
<style scoped>

</style>